<template>
  <div class="maincen">
    <div class="catalog">
      <div class="line"></div>
      <div class="catalogTit">个人资料</div>
    </div>
    <div class="center">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="个人资料" name="first">
          <div class="content">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="用户昵称：" prop="nickname">
                <el-input
                  v-model="ruleForm.nickname"
                  placeholder="请输入您的账号昵称"
                ></el-input>
              </el-form-item>
              <el-form-item prop="picUrl">
                <div class="head">
                  <div>用户头像：</div>
                  <div>
                    <el-upload
                      class="avatar-uploader"
                      :action="getUrl"
                      :show-file-list="false"
                      :on-success="handleAvatarSuccess"
                      :before-upload="beforeAvatarUpload"
                      name="files"
                      :on-progress="progress"
                      :headers="headerUrl"
                      :data="picUpload"
                      accept=".jpg, .png, .JPG, .jpeg, .JPEG, .PNG"
                    >
                      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="用户姓名：" prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入您的真实姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="phone">
                <el-input
                  v-model="ruleForm.phone"
                  :disabled="true"
                  placeholder="请输入您的手机号"
                ></el-input>
              </el-form-item>
              <el-form-item label="性别:" prop="sex">
                <el-select v-model="ruleForm.sex" placeholder="请选择活动区域">
                  <el-option label="男" :value="1"></el-option>
                  <el-option label="女" :value="0"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="所属区域:" prop="region">
                <el-cascader
                  size="large"
                  :options="options"
                  v-model="ruleForm.selectedOptions"
                  @change="addressChange"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="所属院校:" prop="schId">
                <el-select
                  v-model="ruleForm.schId"
                  placeholder="请选择所属院校"
                >
                  <el-option
                    v-for="item in schList"
                    :key="item.fid"
                    :label="item.schName"
                    :value="item.fid"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="班级人数：" prop="classnum">
                <el-input
                  v-model="ruleForm.classnum"
                  placeholder="请输入您的班级人数"
                ></el-input>
              </el-form-item>
            </el-form>
            <div class="preserve" @click="submitForm('ruleForm')">保存</div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="修改密码" name="second">
          <div class="content">
            <el-form
              :model="changePasswordForm"
              :rules="pswRule"
              ref="changePasswordForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="新密码：" prop="password">
                <el-input
                  v-model="changePasswordForm.password"
                  autocomplete="off"
                  type="password"
                  placeholder="请输入新密码"
                ></el-input>
              </el-form-item>
              <el-form-item label="确认密码：" prop="confirmPassword">
                <el-input
                  v-model="changePasswordForm.confirmPassword"
                  autocomplete="off"
                  type="password"
                  placeholder="请确认新密码"
                ></el-input>
              </el-form-item>

              <el-form-item label="手机号：" prop="phone">
                <el-input
                  v-model="changePasswordForm.phone"
                  placeholder="请输入您的手机号"
                ></el-input>
                <div
                  v-if="isShowCodeBtn"
                  class="phonesend"
                  @click="sendeVercode"
                >
                  发送验证码
                </div>
                <div v-else class="phonesend">{{ second }}s后重新获取</div>
              </el-form-item>
              <el-form-item label="验证码：" prop="vercode">
                <el-input
                  v-model="changePasswordForm.vercode"
                  placeholder="请输入验证码"
                ></el-input>
              </el-form-item>
            </el-form>
            <div
              class="preserve"
              @click="changePasswordAction('changePasswordForm')"
            >
              保存
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import { api } from '../../assets/api/axios'
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import { mapMutations, mapState, mapGetters } from 'vuex'
import { baseUrl } from '@/config.js'
export default {
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        this.isPhone = false
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        console.log(reg.test(value))
        if (reg.test(value)) {
          this.isPhone = true
          callback()
        } else {
          this.isPhone = false
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      timer: null,
      second: 60,
      isShowCodeBtn: true,
      getUrl: `${baseUrl}upload/uploadImg.do`,
      activeName: 'first',
      ruleForm: {
        selectedOptions: ['110000', '110100', '110101'],
      },
      changePasswordForm: {},
      isPhone: false,
      rules: {
        name: [
          { required: false, message: '请输入用户名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        region: [
          { required: false, message: '请选择活动区域', trigger: 'change' },
        ],
      },
      pswRule: {
        password: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            min: 11,
            validator: checkPhone,
            max: 11,
            message: '请输入正确到手机号',
            trigger: 'blur',
          },
        ],
        confirmPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
        ],
        vercode: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
      },
      imageUrl: '',
      schList: [],
      options: regionData,
      headerUrl: { Authorization: window.localStorage.getItem('token') },
      picUpload: { commonName: 'avatar' },
    }
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event)
    },
    // 手机验证码
    async sendeVercode() {
      if (this.isPhone == true) {
        console.log('手机号=====', this.changePasswordForm.phone)
        var res = await api.post('/front/login/sendMsg.do', {
          phone: this.changePasswordForm.phone,
        })
        if (res.code == 1000) {
          this.$message.success(res.msg)
          this.timer = setInterval(() => {
            this.second--
            if (this.second < 0) {
              clearInterval(this.timer)
              this.timer = null
              this.second = 60
              this.isShowCodeBtn = true
            } else {
              this.isShowCodeBtn = false
            }
          }, 1000)
        }
      }
    },
    // form
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          api
            .post('/front/personal/updateMessage', this.ruleForm)
            .then((result) => {
              console.log('sssssss====', result)
              if (result.code == 1000) {
                this.$message.success(`${result.msg}`)
              } else {
                this.$message.error(result.msg)
              }
            })
            .catch((err) => {})
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changePasswordAction(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            this.changePasswordForm.password ===
            this.changePasswordForm.confirmPassword
          ) {
            api
              .post('front/login/updatePassword', this.changePasswordForm)
              .then((result) => {
                console.log('sssssss====', result)
                if (result.code == 1000) {
                  window.sessionStorage.clear()
                  window.location.href = '/'
                  this.$message.success(`${result.msg},请重新登录`)
                } else {
                  this.$message.error(result.msg)
                }
              })
              .catch((err) => {})
          } else {
            this.$message.error('输入到密码确认不正确，请再次确认')
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    //上传
    handleAvatarSuccess(res, file) {
      console.log('头像数据===', res, file)
      if (res.code == 1000) {
        this.imageUrl = URL.createObjectURL(file.raw)
        this.ruleForm.picUrl = res.data[0].url
      } else {
        this.$message(res.msg)
      }
    },
    progress(event, file, fileList) {
      console.log(file)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    addressChange(arr) {
      if (arr) {
        this.selectedOptions = arr
        this.region = [
          CodeToText[arr[0]],
          CodeToText[arr[1]],
          CodeToText[arr[2]],
        ].toString
        this.ruleForm.province = CodeToText[arr[0]]
        this.ruleForm.city = CodeToText[arr[1]]
        this.ruleForm.area = CodeToText[arr[2]]
      }
    },
    async getSchoolList() {
      var res = await api.post('/school/selectAllNoPage')
      console.log('学校列表===', res)
      this.schList = res.data ? res.data : []
    },
    async getPersonData() {
      var res = await api.post('/front/personal/myMessage')
      console.log('个人信息-===', res)
      this.ruleForm = res.data ? res.data : {}
      this.imageUrl = res.data.picUrl ? res.data.picUrl : null
      if (this.ruleForm.province) {
        this.ruleForm.selectedOptions = [
          TextToCode[this.ruleForm.province].code, // 省
          TextToCode[this.ruleForm.province][this.ruleForm.city].code, // 市
          TextToCode[this.ruleForm.province][this.ruleForm.city][
            this.ruleForm.area
          ].code, // 区/县
        ]
        console.log('城市区域', this.ruleForm.selectedOptions)
      }
    },
  },
  created() {
    this.getSchoolList()
    this.getPersonData()
  },
}
</script>
<style lang="scss" scoped>
.maincen {
  margin: 0 30px;
  min-height: 712px;
}
.catalog {
  overflow: hidden;
  padding: 20px 0 10px;
  border-bottom: 1px solid #e6e6e6;
  .line {
    width: 4px;
    height: 20px;
    background: rgba(181, 14, 5, 1);
    float: left;
    margin-right: 8px;
  }
  .catalogTit {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
  }
}
.itemnewImg {
  margin-top: 10px;
  width: 100%;
  height: 117px;
  img {
    height: 100%;
    width: 100%;
  }
}
.addImg {
  margin-top: 10px;
  width: 185px;
  height: 117px;
  margin-bottom: 60px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: rgba(181, 14, 5, 1);
  margin: 17px 0 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 30px;
  cursor: pointer;
  &:hover {
    color: rgba(181, 14, 5, 1);
  }
}
.preserve {
  width: 100px;
  height: 36px;
  background: rgba(181, 14, 5, 1);
  font-size: 14px;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  line-height: 36px;
  margin: 50px 0 80px;
  cursor: pointer;
}
.head {
  overflow: hidden;
  padding-left: 17px;
  :nth-child(1) {
    float: left;
    font-size: 14px;
    color: #606266;
    // margin-left: 17px;
    line-height: 80px;
    // height: 80px;
  }
  :nth-child(2) {
    float: left;
  }
}
.phonesend {
  width: 150px;
  height: 37px;
  background: rgba(252, 252, 252, 1);
  border-left: 1px solid rgba(230, 230, 230, 1);
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  text-align: center;
  line-height: 38px;
  position: absolute;
  top: 3px;
  right: 188px;
  cursor: pointer;
}
</style>
<style lang="scss">
@import '../../assets/css/centertabs.scss';

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-left: 10px;
  // border-radius: 50%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px !important;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px !important;
  text-align: center;
}
.avatar {
  width: 80px;
  height: 80px;
  display: block;
}
</style>
